<template>
  <div>
    <!-- <template v-if="!loadingScreen"> -->
    <v-col cols="12">
      <router-link to="/orders" style="text-decoration: none" title="Back">
        <v-btn
          color="warning"
          fab
          small
          dark
          style="float: left; margin-left: 5px"
        >
          <v-icon class="fa fa-arrow-left"></v-icon>
        </v-btn>
        <!-- <v-btn @click="check">Check</v-btn> -->
      </router-link>
    </v-col>

    <v-row class="border">
      <v-col cols="2" class="border">
        <v-list dense>
          <v-subheader>TASK ID</v-subheader>
          <v-list-item-group
            v-model="selectedTask"
            color="primary"
            class="ordernum-scroll"
          >
            <v-list-item
              v-for="(i, index) in dataPreview"
              :key="index"
              @click="chooseTask(index)"
            >
              <v-list-item-content style="text-align: left">
                <v-list-item-title
                  style="font-size: 12px"
                  v-text="i._id"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>

      <v-col cols="10" v-if="!loadingScreen">
        <v-subheader>PREVIEW PRODUCTION</v-subheader>
        <v-col cols="12" v-if="selectedTask != undefined">
          <div style="text-align: left">
            <b>Related Order(s): </b> {{ relatedOrder.join(", ") }} -
            <b>ID: </b> {{ selectedTaskData._id }} - <b>Created Date: </b>
            {{ selectedTaskData.created_date }}
          </div>
          <div style="text-align: left">
            <b>Assigner: </b> {{ selectedTaskData.assigner }} -
            <b>Designer: </b> {{ selectedTaskData.designer }} - <b>SKU: </b>
            {{ selectedTaskData.sku }}
          </div>

          <div class="border">
            <v-col class="12" style="font-size: 14px">
              <v-col>
                <v-btn
                  color="success"
                  small
                  style="text-align: right; display: inline"
                  @click="setTask(index)"
                  >Confirm</v-btn
                >
                &nbsp;
                <v-btn
                  color="red"
                  small
                  style="text-align: right; display: inline"
                  @click="setTask(index)"
                  dark
                  >Deny</v-btn
                >
              </v-col>

              <v-row>
                <v-col cols="9">
                  <v-textarea
                    label="Note"
                    auto-grow
                    rows="1"
                    row-height="15"
                    v-model="selectedTaskData.note"
                    @change="showSaveTaskBtn"
                    @keyup="showSaveTaskBtn"
                  ></v-textarea>
                </v-col>
                <v-col cols="2">
                  <v-select
                    :items="listDesigner"
                    :item-text="(obj) => obj.name"
                    :item-value="(obj) => obj.username"
                    label="Select Designer"
                    dense
                    outlined
                    v-model="selectedTaskData.designer"
                    @change="showSaveTaskBtn"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row style="text-align: left">
                <v-col cols="6">
                  <b>Require(s): </b>
                  <div><b>Note: </b>{{ selectedTaskData.note }}</div>
                </v-col>
                <v-col cols="6">
                  <b>Design Image: </b>{{ selectedTaskData.designSize }}
                  <div>
                    <img
                      :src="selectedTaskData.design_url"
                      style="width: 100%; background-color: grey"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-col>
      </v-col>
      <v-col cols="10" v-else>
        <img v-bind:src="require('../../assets/loading/loading.gif')" />
      </v-col>
    </v-row>
    <!-- </template> -->
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import axios from "axios";
//import moment from 'moment'

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "OrderPreview",

  data: () => ({
    loadingScreen: false,
    loader: null,
    loading: false,
    dataPreview: [],
    listDesigner: [],
    listOrderNumber: [],
    listVendor: [],
    selectedTaskData: {},
    selectedTask: undefined,
    item: {},
    relatedOrder: [],
  }),

  watch: {
    selectedTask() {
      console.log("selectedTask: ", this.selectedTask);
      if (this.selectedTask == undefined) {
        this.selectedTaskData = {};
        this.item = {};
      }
    },
  },

  methods: {
    async loadData() {
      //this.loadingScreen = true
      //https://fthzm2m3h3.execute-api.ap-southeast-1.amazonaws.com/orders/review-customily-orders
      var currentSession = await this.$root.$refs.App.currentSession(
        "task-preview-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "tasks?status=Need Review", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("task-preview loadData: ", response);
            // If request is good...
            this.dataPreview = response.data.data.tasks;
            console.log(this.dataPreview);
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession order-preview-loadData-undefined: ",
          currentSession
        );
      }
      //await this.loadImgSize()
      //this.loadingScreen = false
    },

    async chooseTask(index) {
      this.loadingScreen = true;
      this.item = this.dataPreview[index];
      console.log(index);
      this.selectedTaskData = Object.assign({}, this.item);
      console.log("selectedTaskData: ", this.selectedTaskData);
      for (const i of this.selectedTaskData.related_orders) {
        this.relatedOrder.push(i.order_number);
      }
      await this.loadImgSize();
      this.loadingScreen = false;
      // var temp = []
      // this.selectedTaskData.items.push(temp)
      //this.selectedTaskData.items.splice(this.selectedTaskData.length,1)
    },

    addImageProcess(src) {
      return new Promise((resolve) => {
        let img = new Image();
        //console.log("img: ",img)
        img.onload = () => resolve(img.width + "x" + img.height);
        img.onerror = () => resolve("Error Size");
        img.src = src;
      });
    },

    async loadImgSize() {
      this.selectedTaskData["designSize"] = await this.addImageProcess(
        this.selectedTaskData.design_url
      );
    },

    check() {
      console.log("Selected Order: ", this.selectedTask);
    },

    setTask(index) {
      var temp = {};
      console.log(this.selectedTaskData.items[index]);
      if (
        this.selectedTaskData.items[index].isTask == false ||
        this.selectedTaskData.items[index].isTask == null
      ) {
        this.selectedTaskData.items[index].isTask = true;
        this.selectedTaskData.items[index]["dataTask"] = {
          order_number: this.selectedTask,
          order_id: this.selectedTaskData.order_id,
          note: "",
          sku: this.selectedTaskData.items[index].sku,
          vendor_id: this.selectedTaskData.items[index].vendor_id,
          old_design_url: this.selectedTaskData.items[index].design_url,
          designer_username: "",
          assigner_username: "",
          product_code: this.selectedTaskData.items[index].product_code,
          customer_choice: this.selectedTaskData.items[index].customer_choice,
        };

        this.selectedTaskData.items.push(temp);
        this.selectedTaskData.items.splice(
          this.selectedTaskData.items.length - 1,
          1
        );
      } else {
        this.selectedTaskData.items[index].isTask = false;
        this.selectedTaskData.items[index].dataTask = {};

        this.selectedTaskData.items.push(temp);
        this.selectedTaskData.items.splice(
          this.selectedTaskData.items.length - 1,
          1
        );
      }
      //console.log(JSON.stringify(this.dataOrder.items[index]))
    },

    showSaveBtn() {
      var item = {};
      this.selectedTaskData.items.push(item);
      this.selectedTaskData.items.splice(
        this.selectedTaskData.items.length - 1,
        1
      );
    },

    async saveTask(index) {
      const l = this.loader;
      this[l] = !this[l];

      // console.log(index)
      // console.log(JSON.stringify(this.dataOrder.items[index].dataTask))
      var currentSession = await this.$root.$refs.App.currentSession(
        "order-edit-saveTask"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        this.selectedTaskData.items[index].dataTask.assigner_username =
          currentSession.username;
        console.log("data: ", this.selectedTaskData.items[index].dataTask);
        await fetch(window.domain + "tasks", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(this.selectedTaskData.items[index].dataTask),
        })
          .then((response) => response.json())
          .then(async (data) => {
            console.log("order-preview saveTask response: ", data);
            await this.loadData();
            //this.selectedTask = undefined
            //this.selectedTaskData = {}
            //this.item = {}
            this.selectedTask = this.selectedTaskData.next_item;
            this.selectedTaskData = {};
            if (this.selectedTask != null) {
              this.chooseTask(this.selectedTask);
            } else {
              this.selectedTaskData = {};
            }
            console.log("selectedTask: ", this.selectedTask);
            console.log("selectedTaskData: ", this.selectedTaskData);
          });
      } else {
        console.log(
          "currentSession order-edit-saveTask-undefined: ",
          currentSession
        );
      }

      this[l] = false;
      this.loader = null;
    },
  },

  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    this.loadData();
  },
};
</script>

<style scoped>
.ordernum-scroll {
  height: 70vh;
  overflow: auto;
}
</style>